(() => {
  const hero = document.getElementById('hero');
  const video = hero?.querySelector('.zg-core-cinema-video');
  const poster = hero?.querySelector('img.zg-core-cinema-image');
  if (!video || !poster) return;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let started = false;
  const fallback = () => { video.classList.remove('is-playing'); video.pause(); };
  const reveal = () => { if (!reducedMotion.matches && !video.paused && video.readyState >= 2) video.classList.add('is-playing'); };
  video.addEventListener('playing', () => {
    if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(reveal);
    else requestAnimationFrame(reveal);
  });
  video.addEventListener('error', fallback);
  const start = async () => {
    if (started || reducedMotion.matches) return;
    started = true;
    try { await poster.decode(); } catch (_) { /* Keep the image fallback in place. */ }
    // Give the existing poster and headline their first paint before fetching motion.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (reducedMotion.matches) { started = false; return; }
      video.muted = true;
      video.src = video.dataset.src;
      video.play().catch(fallback);
    }));
  };
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) { fallback(); video.removeAttribute('src'); video.load(); started = false; }
    else start();
  });
  start();
})();
